module.exports = __webpack_public_path__ + "wx.7e0dca97.png";